module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Regular.2a45295c.svg";